angular.module("files_types")

    .controller("FilesTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("FILES_TYPES_WRITE");
        $rootScope.title = $filter('translate')('files_types.title');

            $scope.file_type = {};

            $scope.selectMimetypes= [{ id: 'image/png', name: 'image/png' },
                { id: 'image/jpeg', name: 'image/jpeg' },
                { id: 'text/plain', name: 'text/plain' },
                { id: 'application/pdf', name: 'application/pdf' },
                { id: 'application/msword', name: 'application/msword' },
                { id: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', name: 'application/officedocument' }
            ]

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('files_types.title'), url: "files_types.list" },
                { title: $filter('translate')('files_types.title_add') },
            ];
             
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('files_types.title'), url: "files_types.list" },
                { title: $filter('translate')('files_types.title_edit') },
            ];

            Restangular.one('FilesTypes', $stateParams.id).get().then(function (result) {
                
                $scope.file_type = result;                
            });
        }               
                                       
        $scope.save = function () {            
            if (angular.isDefined($scope.file_type.id)) {
                $scope.file_type.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('general.edit_success'));                        
                        $state.go("files_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('FilesTypes').post($scope.file_type).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('general.edit_success'));
                        $state.go("files_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('events_types.delete_message') + " " + $scope.event_type.name + "?",
                onAccept: function () {
                    $scope.event_type.remove().then(function () {
                        toastr.success($filter('translate')('general.deleted_success'));
                        $state.go("files_types.list");
                    });
                }
            });
        };        

}])

;

